var map = {
	"./ar-EG.json": [
		"449d",
		"lang-ar-EG-json"
	],
	"./da-DK.json": [
		"7107",
		"lang-da-DK-json"
	],
	"./de-DE.json": [
		"3f18",
		"lang-de-DE-json"
	],
	"./en-US.json": [
		"4bef"
	],
	"./es-MX.json": [
		"5b5c",
		"lang-es-MX-json"
	],
	"./fr-CA.json": [
		"a6b1",
		"lang-fr-CA-json"
	],
	"./ja-JP.json": [
		"a3e2",
		"lang-ja-JP-json"
	],
	"./kl-GL.json": [
		"c8af",
		"lang-kl-GL-json"
	],
	"./pt-BR.json": [
		"a2a4",
		"lang-pt-BR-json"
	],
	"./zh-CN.json": [
		"6366",
		"lang-zh-CN-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8825";
module.exports = webpackAsyncContext;